import { BettingSites } from "./BettingSites";

export default BettingSites;